import { appServiceApi } from "../../../app/appServiceApi";
import { API_URL } from "../../../constants/apiUrl";
import { GetQueryArgsType } from "../../../types";
import {
  GetAllBatchDataParamsType,
  GetAllBatchDataType,
  GetAllBatchPendingListDataParamsType,
  GetAllBatchPendingListDataType,
  GetAllDisbursementTypeDataType,
  GetAllDisbursementTypeParamsType,
  GetBatchLogDataParamsType,
  GetBatchLogDataType,
  GetSingleBatchDataType,
  GetUserPerformBatchDataParamsType,
  GetUserPerformBatchDataType,
} from "../../../types/portal/batch";

export const batchApi = appServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    createBatch: builder.mutation({
      query: (data) => ({
        url: API_URL.createBatch,
        method: "POST",
        body: data,
      }),
    }),

    getAllBatch: builder.query<
      GetAllBatchDataType,
      GetQueryArgsType<GetAllBatchDataParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getAllBatch,
        params: queryArgs.params,
      }),
      providesTags: ["GetAllBatch"],
    }),

    getSingleBatch: builder.query<GetSingleBatchDataType, any>({
      query: (id) => ({
        url: `${API_URL.getSingleBatch}/${id}`,
      }),
      providesTags: (_, __, id) => [{ type: "GetSingleBatch", id }],
    }),

    updateBatch: builder.mutation({
      query: ({ id, data }) => ({
        url: `${API_URL.updateBatch}/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetAllBatch", "GetSingleBatch", "GetBatchLog"];
        return [];
      },
    }),

    getBatchLog: builder.query<
      GetBatchLogDataType,
      GetQueryArgsType<GetBatchLogDataParamsType>
    >({
      query: ({ params }) => ({
        url: `${API_URL.getBatchLog}/${params?.id}`,
      }),
      providesTags: (_, __, { params }) => [
        { type: "GetBatchLog", id: params?.id },
      ],
    }),

    getUserPerformBatch: builder.query<
      GetUserPerformBatchDataType,
      GetQueryArgsType<GetUserPerformBatchDataParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getUserPerformBatch,
        params: queryArgs.params,
      }),
      providesTags: ["GetUserPerformBatch"],
    }),

    createBatchVendor: builder.mutation({
      query: (data) => ({
        url: API_URL.createBatchVendor,
        method: "POST",
        body: data,
      }),
    }),

    getAllBatchVendor: builder.query<
      GetAllBatchDataType,
      GetQueryArgsType<GetAllBatchDataParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getAllBatchVendor,
        params: queryArgs.params,
      }),
      providesTags: ["GetAllBatchVendor"],
    }),

    createBatchForDigigo: builder.mutation({
      query: (data) => ({
        url: API_URL.createBatchForDigigo,
        method: "POST",
        body: data,
      }),
    }),

    getAllBatchPendingList: builder.query<
      GetAllBatchPendingListDataType,
      GetQueryArgsType<GetAllBatchPendingListDataParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getAllBatchPendingList,
        params: queryArgs.params,
      }),
      providesTags: ["GetAllBatchPendingList"],
    }),

    pendingBatchBulkAction: builder.mutation({
      query: ({ data }) => ({
        url: `${API_URL.pendingBatchBulkAction}`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result)
          return [
            "GetAllBatch",
            "GetSingleBatch",
            "GetAllBatchPendingList",
            "GetBatchLog",
          ];
        return [];
      },
    }),

    updateBatchName: builder.mutation({
      query: ({ id, data }) => ({
        url: `${API_URL.updateBatchName}/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetAllBatch", "GetSingleBatch", "GetBatchLog"];
        return [];
      },
    }),

    batchRejectByMaker: builder.mutation({
      query: ({ id, data }) => ({
        url: `${API_URL.batchRejectByMaker}/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetAllBatch", "GetSingleBatch", "GetBatchLog"];
        return [];
      },
    }),

    createDisbursementType: builder.mutation({
      query: (data) => ({
        url: API_URL.createDisbursementType,
        method: "POST",
        body: data,
      }),
    }),

    getAllDisbursementType: builder.query<
      GetAllDisbursementTypeDataType,
      GetQueryArgsType<GetAllDisbursementTypeParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getAllDisbursementType,
        params: queryArgs.params,
      }),
      providesTags: ["GetAllDisbursementType"],
    }),
  }),
});

export const {
  useCreateBatchMutation,
  useGetAllBatchQuery,
  useGetSingleBatchQuery,
  useUpdateBatchMutation,
  useGetBatchLogQuery,
  useGetUserPerformBatchQuery,
  useCreateBatchVendorMutation,
  useGetAllBatchVendorQuery,
  useCreateBatchForDigigoMutation,
  useGetAllBatchPendingListQuery,
  usePendingBatchBulkActionMutation,
  useUpdateBatchNameMutation,
  useBatchRejectByMakerMutation,
  useCreateDisbursementTypeMutation,
  useGetAllDisbursementTypeQuery,
} = batchApi;
